import { A } from "@solidjs/router";
import { Show, type JSX } from "solid-js";

export default function Cell(props: {
  href?: string;
  state?: unknown;
  onClick?: () => void;
  title: JSX.Element | string;
  subtitle?: JSX.Element | string;
  value?: JSX.Element | string;
  chevron?: boolean;
  destructive?: boolean;
  leading?: JSX.Element;
  trailing?: JSX.Element;
  disabled?: boolean;
  inset?: boolean;
}) {
  const className = () =>
    `tg-cell${props.destructive ? " is-destructive" : ""}${
      props.inset ? " is-inset" : ""
    }${props.leading ? " has-leading" : ""}`;

  const inner = () => (
    <>
      <Show when={props.leading}>
        <span class="tg-cell-leading">{props.leading}</span>
      </Show>
      <span class="tg-cell-body">
        <span class="tg-cell-title">{props.title}</span>
        <Show when={props.subtitle}>
          <span class="tg-cell-subtitle">{props.subtitle}</span>
        </Show>
      </span>
      <Show when={props.value}>
        <span class="tg-cell-value">{props.value}</span>
      </Show>
      {props.trailing}
      <Show when={props.chevron}>
        <Chevron />
      </Show>
    </>
  );

  if (props.href) {
    return (
      <A href={props.href} state={props.state} class={className()}>
        {inner()}
      </A>
    );
  }

  if (props.onClick) {
    return (
      <button
        type="button"
        class={className()}
        disabled={props.disabled}
        onClick={props.onClick}
      >
        {inner()}
      </button>
    );
  }

  return <div class={className()}>{inner()}</div>;
}

function Chevron() {
  return (
    <svg class="tg-chevron" viewBox="0 0 9 16" aria-hidden="true">
      <path
        d="M1.5 1.5L7.5 8L1.5 14.5"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
